import { render, staticRenderFns } from "./areaSelect.vue?vue&type=template&id=a7b20cfa&scoped=true&"
import script from "./areaSelect.vue?vue&type=script&lang=js&"
export * from "./areaSelect.vue?vue&type=script&lang=js&"
import style0 from "./areaSelect.vue?vue&type=style&index=0&id=a7b20cfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b20cfa",
  null
  
)

export default component.exports